export default __webpack_public_path__ + "static/media/LuxRooms.41e4de71.jpg";